<div class="form-group form-input-group">
  <label class="form-input-label" *ngIf="label">{{label}}</label>
  <input [type]="type" [(ngModel)]="value" class="form-control form-input" [ngClass]="classes"
         [placeholder]="placeholder" [disabled]="disabled" [id]="id" [name]="name">
  <div class="invalid-feedback" *ngIf="invalidFeedback && isInvalid">{{invalidFeedback}}</div>
</div>
